import { Component, inject, input, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { FieldTree } from "@angular/forms/signals";
import { DspStrategyService } from "@front/m19-services";
import { TranslocoDirective } from "@jsverse/transloco";
import { AsinSelectionComponent } from "@m19-board/shared/asin-selection/asin-selection.component";

export interface DspCreateStrategyAsinsModel {
  asins: string[];
}

@Component({
  selector: "app-dsp-create-strategy-asins-step",
  host: {
    class: "block h-full min-h-0",
  },
  imports: [TranslocoDirective, AsinSelectionComponent],
  templateUrl: "./dsp-create-strategy-asins-step.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DspCreateStrategyAsinsStepComponent implements OnInit {
  private readonly strategyService = inject(DspStrategyService);

  readonly asins = input.required<FieldTree<DspCreateStrategyAsinsModel>>();

  readonly asinsLimit = this.strategyService.maxAsinsPerStrategy;

  ngOnInit() {
    this.asins().asins().markAsDirty();
  }

  selectAsins(asins: string[]) {
    this.asins().asins().markAsDirty();
    this.asins().asins().value.set(asins);
  }
}
